module.exports = __webpack_public_path__ + "images/b57270b0f7f74b6bbd961d9c3be45b6b-cs4.jpg";